import {INSTALLERS_SUCCESS, INSTALLERS_ERROR, INSTALLER_COMPANY_SUCCESS, INSTALLER_COMPANY_ERROR} from '../constants/Constants';

let initialstate = {
    installers: [],
    inprogress: false,
    installerCompany: {},
    installerCompanyToEdit: undefined,
    saving: false,
    date: new Date()
};

export default function InstallerCompanyStore(state = initialstate, action = {}) {
    switch (action.type) {
        case INSTALLERS_SUCCESS:
            return {
                ...state,
                inprogress: false,
                installers: action.installers
            };
        case INSTALLERS_ERROR:
            return {
                ...state,
                inprogress: false,
                installers: []
            };
        case INSTALLER_COMPANY_SUCCESS:
            return {
                ...state,
                installerCompany: action.installerCompany
            };
        case INSTALLER_COMPANY_ERROR:
            return {
                ...state,
                installerCompany: {}
            };
        case 'INSTALLER_COMPANY_EDIT':
            return {
              ...state,
              installerCompanyToEdit: action.installerCompany
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /src/reducers/InstallerCompanyReducer.js